import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-pressed", "disabled"]
const _hoisted_2 = { class: "product-add-label" }

import { computed } from 'vue';
import { COUPON_STATUS_FILTERS } from '@/constants/CouponConstants';

interface Props {
  couponId: string;
  availableLabel: string;
  clippedLabel: string;
  redeemedLabel: string;
  couponFilter?: string;
  isClipped?: boolean;
  isRedeemed?: boolean;
  disabled?: boolean;
  handleClip?: Function;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCCouponClipButtonModern',
  props: {
    couponId: {},
    availableLabel: {},
    clippedLabel: {},
    redeemedLabel: {},
    couponFilter: { default: undefined },
    isClipped: { type: Boolean, default: false },
    isRedeemed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    handleClip: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props;

const isDisabled = computed(() => props.disabled);

const isClippedOrRedeemed = computed(
  () =>
    props.isClipped ||
    props.isRedeemed ||
    props.couponFilter === COUPON_STATUS_FILTERS.CLIPPED ||
    props.couponFilter === COUPON_STATUS_FILTERS.REDEEMED,
);

const label = computed({
  get: () => {
    if (props.couponFilter === COUPON_STATUS_FILTERS.CLIPPED) {
      return props.clippedLabel;
    }
    if (props.couponFilter === COUPON_STATUS_FILTERS.REDEEMED) {
      return props.redeemedLabel;
    }
    if (props.isClipped) {
      return props.clippedLabel;
    }
    if (props.isRedeemed) {
      return props.redeemedLabel;
    }
    return props.availableLabel;
  },
  set: newLabel => newLabel,
});

const handleClick = (event: MouseEvent) => {
  if (!props.isClipped) {
    props.handleClip(props.couponId, event.currentTarget as HTMLElement);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["product-actions wc-card-hover", { clipped: isClippedOrRedeemed.value }]),
    type: "button",
    id: 'coupon_' + _ctx.couponId,
    onClick: handleClick,
    "aria-pressed": _ctx.isClipped || _ctx.isRedeemed ? 'true' : 'false',
    disabled: isDisabled.value || isClippedOrRedeemed.value
  }, [
    (!_ctx.isClipped && !_ctx.isRedeemed)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          icon: "scissors",
          class: "product-add-icon",
          "aria-hidden": "true"
        }))
      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 1,
          icon: "check",
          class: "product-add-icon",
          "aria-hidden": "true"
        })),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", _hoisted_2, _toDisplayString(label.value), 1)
  ], 10, _hoisted_1))
}
}

})